import { reduxKey } from './constants';
export var hasUsersOnPage = function (state) {
    return state[reduxKey] && state[reduxKey]['usersOnPage'] ? true : false;
};
export var getUsersOnPage = function (state) {
    return (state[reduxKey] && state[reduxKey]['usersOnPage']) || {};
};
export var getServerFriends = function (state, alpha) {
    return (state[reduxKey] && state[reduxKey]['friends'][alpha]) || [];
};
export var getFriendsPage = function (state, alpha) {
    return (state[reduxKey] && state[reduxKey].friendPages[alpha]) || 0;
};
//# sourceMappingURL=selectors.js.map